<script setup>
import Navbar from '@/Layouts/Partials/Navbar.vue'
import Footer from '@/Layouts/Partials/Footer.vue'
import GetCouponModal from '@/Layouts/Partials/GetCouponModal.vue'

const props = defineProps({
    meta_title: {
        type: String,
        default: 'Daňové přiznání pro OSVČ online – Jednoduché a rychlé podání',
        required: false,
    },

    meta_description: {
        type: String,
        default:
            'Jste OSVČ a hledáte snadný způsob, jak podat daňové přiznání online? S námi to zvládnete rychle a bez stresu. Ušetřete čas a vyhněte se chybám při podání daní.',
        required: false,
    },

    meta_canonical: {
        type: String,
        required: false,
    },
})
</script>

<template>
    <Head>
        <title>{{ meta_title }}</title>

        <meta
            type="description"
            head-key="description"
            name="description"
            :content="meta_description"
            inertia
        />

        <link
            v-if="meta_canonical"
            rel="canonical"
            :href="meta_canonical"
        />
    </Head>

    <Navbar />

    <main class="min-h-screen">
        <slot name="content" />
        <slot name="modals" />

        <GetCouponModal />
    </main>

    <Footer />
</template>
